const getters = {
  processing: (state) => state.processing,
  bulkProcessing: (state) => state.bulkProcessing,
  bonuses: (state) => state.bonuses,
};

export default getters;
